import axios from 'axios';
import picsioConfig from '../../../../../config';
import { getLatestCollection } from '../history';

/**
 * Get urls to download from zipper
 * @param {Object} data
 * @returns {Promise}
 */
export default function getZipUrls(data) {
  const collectionId = getLatestCollection();
  if (collectionId) data.downloadFrom = collectionId;

  return axios.post(
    picsioConfig.zipperZipUrl,
    data,
    { headers: { 'Content-Type': 'application/json' } },
  );
}
